<template>
<v-container fluid class="my-4" v-if="visible==true">
  <v-card class="pa-2 campaign-card" elevation="2">
      <div
        class="d-flex align-center justify-space-between pa-2 "
      >
        <!-- Títol -->
        <span class="text-h7 font-weight-bold">
          {{ titol }}
        </span>

        <!-- Botons -->
        <div>
          <v-btn
            v-if="!minimitzatTaula"
            size="small"
            variant="text"
            icon="mdi-window-minimize"
            @click="minimitzatTaula = true"
          />
          <v-btn
            v-else
            size="small"
            variant="text"
            icon="mdi-window-maximize"
            @click="minimitzatTaula = false"
          />
        </div>
      </div>

    <!-- Barra superior amb buscador i exportació -->
    <div v-show="!minimitzatTaula" class="pa-4">
        <v-row class="mb-4">
          <v-col>
              <v-text-field
              v-model="search"
              label="Buscar en las zonas de reparto ..."
              prepend-icon="mdi-magnify"
              clearable
              />
          </v-col>
          <v-col cols="auto">
              <v-tooltip text="Exportar CSV">
              <template #activator="{ props }">
                  
              <v-btn 
                color="green" 
                class="btn-descargar"
                v-bind="props" 
                @click="exportar"
              >
                Descargar excel
              </v-btn>

              </template>
              </v-tooltip>
          </v-col>
        </v-row>

        <!-- Taula -->
        <v-data-table
        :items="items"
        :headers="headers"
        class="elevation-1"
        item-value="id"
        no-data-text="No hay campañas disponibles"
        :search="search"
        >
        <!-- Estat distribució -->
        <template #item.estadoDistribucion="{ item }">
            <v-tooltip :text="item.estadoDistribucion.text">
            <template #activator="{ props }">
                <v-icon :color="item.estadoDistribucion.color" small v-bind="props">
                {{ item.estadoDistribucion.icon }}
                </v-icon>
            </template>
            </v-tooltip>
        </template>

        <!-- Botó mapa -->
        <template #item.mapa="{ item }">
            <v-tooltip text="Ver mapa">
            <template #activator="{ props }">
                <v-btn
                icon
                size="x-small"
                color="#00819d"
                v-bind="props"
                @click="$emit('mapa', item)"
                >
                <v-icon>mdi-map</v-icon>
                </v-btn>
            </template>
            </v-tooltip>
        </template>
        </v-data-table>
    </div>
  </v-card>
  </v-container>
</template>

<script setup>
import { ref, computed } from 'vue'

const props = defineProps({
  items: { type: Array, default: () => [] },
  headers: { type: Array, required: true },
  titol: { type: String, default: '' },
  startMinimized: { type: Boolean, default: false },
  visible: { type: Boolean, default: true }
})

const emit = defineEmits(['exportar', 'mapa', 'update:startMinimized', 'update:visible'])

const search = ref('')

const minimitzatTaula = computed({
  get: () => props.startMinimized,
  set: (v) => emit('update:startMinimized', v)
})

const visible = computed({
  get: () => props.visible,
  set: (v) => emit('update:visible', v)
})

function exportar() {
  emit('exportar', props.items)
}
</script>


<style>
.btn-descargar {
  border-radius: 40px;
  text-transform: capitalize;  
  font-size: 0.95rem;          
  letter-spacing: normal;      
  padding: 6px 30px;           
  margin-top: 10px;
}
</style>